import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'ai-mate.chat-error.title',
		defaultMessage: "We're not sure what went wrong",
		description: 'Generic error message',
	},
	description: {
		id: 'ai-mate.chat-error.description',
		defaultMessage: 'Try <btn>reload chat</btn>.',
		description: 'Error title',
	},
	rateLimitedTitle: {
		id: 'ai-mate.chat-error.rate-limited-title',
		defaultMessage: 'Too many requests',
		description: 'Rate limited error title',
	},
	rateLimitedDescription: {
		id: 'ai-mate.chat-error.rate-limited-description',
		defaultMessage: 'You have reached the maximum number of requests. Please try again later.',
		description: 'Rate limited error message',
	},
});
